import { useOrderManagementServer } from '@konsolenkost-de/order_management_server_sdk_vue';
import * as Sentry from '@sentry/vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp } from 'vue';
import App from './App.vue';
import './assets/main.css';
import { i18n } from './i18n';
import { pinia } from './pinia';
import router from './router';

const { VITE_SENTRY_DSN, VITE_APP_VERSION, VITE_API_URL } = import.meta.env;

useOrderManagementServer(VITE_API_URL);

const app = createApp(App);

if (VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: VITE_SENTRY_DSN,
    release: VITE_APP_VERSION,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'console') {
        return null;
      }
      return breadcrumb;
    },
  });
}

app.use(router);
app.use(i18n, { inject: true });
app.use(pinia);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  },
});

app.mount('#app');
